import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface ReactionPayload {
	social_post: string;
	reaction: string;
}

const reactToPost = async (payload: ReactionPayload) => {
	const response = await cmsClient.post("/reactions/", payload);
	return response.data;
};

const useReactToPost = () => {
	const queryClient = useQueryClient();

	return useMutation(reactToPost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useReactToPost;
